// extracted by mini-css-extract-plugin
export default {"clear-filter-button":"ClearFilter_clear-filter-button__YVXsO"};